module.exports = __webpack_public_path__ + "static/media/icons - Edit.b06c14db.svg";